import React from 'react';
import { Link } from 'react-router-dom';
import { coreServices } from '../../lib/servicesData';

const ServicesPreview = () => (
  <section className="bg-white px-6 py-20 lg:px-8 lg:py-28">
    <div className="mx-auto max-w-7xl">
      <div className="grid gap-8 lg:grid-cols-[.75fr_1.25fr] lg:items-end">
        <div>
          <p className="section-kicker">What we build</p>
          <h2 className="mt-4 max-w-xl text-4xl font-semibold leading-[1.04] tracking-[-0.045em] text-[#102A3A] md:text-5xl">A focused set of ways to grow.</h2>
        </div>
        <div className="lg:justify-self-end">
          <p className="max-w-xl text-base leading-7 text-[#63747E]">Start with the business outcome. We will recommend a small, clear first release rather than sell you a pile of features.</p>
          <Link to="/pricing" className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#176B8A]">See transparent starting prices <span aria-hidden="true">&rarr;</span></Link>
        </div>
      </div>

      <div className="mt-12 grid gap-px overflow-hidden rounded-[1rem] border border-[#DCE4E8] bg-[#DCE4E8] lg:grid-cols-3">
        {coreServices.map((service, index) => (
          <Link key={service.id} to={`/services/${service.id}`} className="group flex min-h-[390px] flex-col bg-[#FBFCFD] p-7 transition-colors duration-300 hover:bg-white md:p-9">
            <div className="flex items-center justify-between">
              <div className="service-icon flex h-11 w-11 items-center justify-center rounded-xl text-white" style={{ backgroundColor: service.accent }}>{service.icon}</div>
              <span className="text-xs font-semibold tabular-nums text-[#8A9AA3]">0{index + 1}</span>
            </div>
            <p className="mt-10 text-[11px] font-bold uppercase tracking-[0.17em]" style={{ color: service.accent }}>{service.eyebrow}</p>
            <h3 className="mt-3 text-2xl font-semibold tracking-[-0.03em] text-[#102A3A]">{service.title}</h3>
            <p className="mt-4 text-sm leading-6 text-[#63747E]">{service.shortDesc}</p>
            <div className="mt-auto flex items-end justify-between border-t border-[#DCE4E8] pt-6">
              <div>
                <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-[#8A9AA3]">Starting at</p>
                <p className="mt-1 font-semibold text-[#102A3A]">{service.startingAt}</p>
              </div>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#E7F0F4] text-[#176B8A] transition duration-300 group-hover:translate-x-1 group-hover:bg-[#176B8A] group-hover:text-white" aria-hidden="true">&rarr;</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesPreview;
